import React from 'react';
import PropTypes from 'prop-types';

const svgsPath = (svg) => `/assets/images/${svg}.svg`;

export default function Image({ name, path, ...rest }) {
  return <img src={path(name)} alt="" {...rest} />;
}

Image.defaultProps = {
  path: svgsPath,
};

Image.propTypes = {
  name: PropTypes.string.isRequired,
  path: PropTypes.string,
};
